import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { CircularProgress, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: theme.palette.background.default,
    },
    message: {
      marginTop: '1em',
    },
  })
);

export default function CallEnded() {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <CircularProgress />
      <Typography variant="h6" className={classes.message}>
        Call ended. Returning to BookDoc portal…
      </Typography>
    </div>
  );
}
